export const translationReplacer = (key: string, t: (key: string) => string) =>
  t(key).replace(/%20/g, ' ')
